import {
    AgentContentJobMode,
    AgentContentJobStatus,
} from 'common/src/api/contentFrontendVsContentBackend/agentContent'
import { AnthropicModelName } from 'common/src/api/contentFrontendVsContentBackend/llm'

// antd Tag colors — shared by every status rendering (activity/history
// tables, run drawer) so success vs failure reads at a glance
export const AGENT_STATUS_TAG_COLOR: Record<AgentContentJobStatus, string> = {
    [AgentContentJobStatus.succeeded]: 'green',
    [AgentContentJobStatus.failed]: 'red',
    [AgentContentJobStatus.running]: 'blue',
    [AgentContentJobStatus.queued]: 'gold',
    [AgentContentJobStatus.waitingForLock]: 'gold',
    [AgentContentJobStatus.orphaned]: 'orange',
    [AgentContentJobStatus.canceled]: 'default',
}

export const AGENT_MODE_LABEL: Record<AgentContentJobMode, string> = {
    [AgentContentJobMode.fillGaps]: 'Fill gaps',
    [AgentContentJobMode.fromScratch]: 'From scratch',
    [AgentContentJobMode.adHoc]: 'Ad hoc',
    [AgentContentJobMode.counterpartBackfill]: 'Counterpart backfill',
    [AgentContentJobMode.formulaSheet]: 'Formula sheet',
    [AgentContentJobMode.sourceMaterialImport]: 'Source material import',
    [AgentContentJobMode.previousExamAuthoring]: 'Previous exam authoring',
    [AgentContentJobMode.courseWideEdit]: 'Course-wide edit',
}

export const AGENT_MODEL_LABEL: Record<AnthropicModelName, string> = {
    [AnthropicModelName['claude-opus-5-5']]: 'Opus 5.5',
    [AnthropicModelName['claude-sonnet-5-5']]: 'Sonnet 5.5',
    [AnthropicModelName['claude-fable-5']]: 'Fable 5',
    [AnthropicModelName['claude-opus-5']]: 'Opus 5',
    [AnthropicModelName['claude-opus-4-6']]: 'Opus 4.6',
    [AnthropicModelName['claude-opus-4-5']]: 'Opus 4.5',
    [AnthropicModelName['claude-sonnet-5']]: 'Sonnet 5',
    [AnthropicModelName['claude-sonnet-4-5']]: 'Sonnet 4.5',
    [AnthropicModelName['claude-haiku-4-5']]: 'Haiku 4.5',
    [AnthropicModelName['claude-opus-4-1']]: 'Opus 4.1',
    [AnthropicModelName['claude-opus-4-0']]: 'Opus 4',
    [AnthropicModelName['claude-sonnet-4-0']]: 'Sonnet 4',
    [AnthropicModelName['claude-3-7-sonnet-latest']]: 'Sonnet 3.7',
}

export const getAgentModelLabel = (modelName: AnthropicModelName): string =>
    AGENT_MODEL_LABEL[modelName] ?? modelName
